module.exports = __webpack_public_path__ + "img/source_book-item6.bcd0fb9f.png";